import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  @media ${({ theme }) => theme.device.mobile} {
    padding: 16px;
    margin-top: 16px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.24px;
  color: ${ColorPalette.HEX.PineTree};
  margin-bottom: 32px;
`;
